/**
 * cds-commune-selector.js
 * Selector de comunas independiente — diseño basado en el selector original de Corrales del Sur.
 * v3.0.0 — 2026-04-07
 */
(function () {
  'use strict';

  if (window.__CDS_SELECTOR_MOUNTED__) return;
  window.__CDS_SELECTOR_MOUNTED__ = true;

  // ─── Datos de comunas ─────────────────────────────────────────────────────
  const REGIONS = [
    {
      id: 'RM',
      name: 'Región Metropolitana de Santiago',
      communes: [
        { id: 302, name: 'Cerrillos' },
        { id: 303, name: 'Cerro Navia' },
        { id: 304, name: 'Conchalí' },
        { id: 305, name: 'El Bosque' },
        { id: 306, name: 'Estación Central' },
        { id: 307, name: 'Huechuraba' },
        { id: 308, name: 'Independencia' },
        { id: 309, name: 'La Cisterna' },
        { id: 310, name: 'La Florida' },
        { id: 311, name: 'La Granja' },
        { id: 312, name: 'La Pintana' },
        { id: 313, name: 'La Reina' },
        { id: 314, name: 'Las Condes' },
        { id: 315, name: 'Lo Barnechea' },
        { id: 316, name: 'Lo Espejo' },
        { id: 317, name: 'Lo Prado' },
        { id: 318, name: 'Macul' },
        { id: 319, name: 'Maipú' },
        { id: 321, name: 'Ñuñoa' },
        { id: 322, name: 'Pedro Aguirre Cerda' },
        { id: 323, name: 'Peñalolén' },
        { id: 324, name: 'Providencia' },
        { id: 325, name: 'Pudahuel' },
        { id: 326, name: 'Quilicura' },
        { id: 327, name: 'Quinta Normal' },
        { id: 328, name: 'Recoleta' },
        { id: 329, name: 'Renca' },
        { id: 330, name: 'San Joaquín' },
        { id: 331, name: 'San Miguel' },
        { id: 332, name: 'San Ramón' },
        { id: 333, name: 'Santiago' },
        { id: 334, name: 'Vitacura' },
        { id: 337, name: 'Puente Alto' },
        { id: 338, name: 'Colina' },
        { id: 340, name: 'San Bernardo' },
        { id: 342, name: 'Buin' },
        { id: 341, name: 'Padre Hurtado' },
      ].sort((a, b) => a.name.localeCompare(b.name, 'es')),
    },
    {
      id: 'LL',
      name: 'Región de Los Lagos',
      communes: [
        { id: 244, name: 'Osorno' },
        { id: 245, name: 'San Juan de la Costa' },
        { id: 252, name: 'Puerto Varas' },
        { id: 256, name: 'Frutillar' },
        { id: 267, name: 'Río Negro' },
      ].sort((a, b) => a.name.localeCompare(b.name, 'es')),
    },
  ];

  // ─── Mapa comuna → location ID de Shopify (debe coincidir con Checkout.jsx) ─────
  var COMMUNE_TO_LOC = {
    302:'942178329',  303:'942178329',  305:'942178329',  306:'942178329',
    308:'942178329',  309:'942178329',  310:'942178329',  311:'942178329',
    312:'942178329',  313:'942178329',  314:'942178329',  316:'942178329',
    317:'942178329',  318:'942178329',  319:'942178329',  321:'942178329',
    322:'942178329',  323:'942178329',  324:'942178329',  327:'942178329',
    329:'942178329',  330:'942178329',  331:'942178329',  332:'942178329',
    337:'942178329',  340:'942178329',  341:'942178329',
    342:'942178329',
    304:'86750101753', 307:'86750101753', 315:'86750101753', 325:'86750101753',
    326:'86750101753', 328:'86750101753', 333:'86750101753', 334:'86750101753', 338:'86750101753',
    201:'37094129739', 244:'37094129739', 245:'37094129739', 267:'37094129739',
    252:'78995718393', 256:'78995718393',
  };

  function getLocation(communeId) {
    return COMMUNE_TO_LOC[parseInt(communeId, 10)] || '942178329';
  }

  // ─── Estado ───────────────────────────────────────────────────────────────
  const LS_KEY = 'amplifica-shipping-location';
  const CDS_BACKEND = 'https://invernadas-copy-production.up.railway.app';

  // Comunas con cobertura de despacho (se carga al iniciar)
  var shippingCoveredIds = null; // null = aún no cargado, [] = sin datos DB (mostrar todo)

  function loadShippingCoverage() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', CDS_BACKEND + '/availability/communes');
    xhr.onload = function() {
      try {
        var data = JSON.parse(xhr.responseText);
        shippingCoveredIds = data.shipping_communes || [];
      } catch(e) {
        shippingCoveredIds = [];
      }
    };
    xhr.onerror = function() { shippingCoveredIds = []; };
    xhr.send();
  }

  function getSaved() {
    try {
      const raw = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (!raw) return null;
      // Normalizar formato antiguo: { comunaId, comunaText, regionText }
      if (raw.comunaId && !raw.communeId) {
        raw.communeId = parseInt(raw.comunaId, 10);
        raw.communeName = raw.comunaText || '';
      }
      return raw;
    } catch { return null; }
  }

  function save(regionId, communeId, communeName) {
    const data = { regionId, communeId, communeName, ts: Date.now() };
    localStorage.setItem(LS_KEY, JSON.stringify(data));
    updateCartAttributes(communeId, communeName);
    return data;
  }

  // ─── Cart attributes ──────────────────────────────────────────────────────
  // Escribe todos los atributos que el checkout extension y el webhook necesitan.
  // Absorbe lo que antes escribían Amplifica (amplifica_*) y Zapiet (_selectedComuna*).
  function updateCartAttributes(communeId, communeName) {
    // Buscar región a partir de la comuna
    var region = null;
    var numId = parseInt(communeId, 10);
    for (var ri = 0; ri < REGIONS.length; ri++) {
      for (var ci = 0; ci < REGIONS[ri].communes.length; ci++) {
        if (REGIONS[ri].communes[ci].id === numId) { region = REGIONS[ri]; break; }
      }
      if (region) break;
    }

    var attrs = {
      // Atributos CDS (fuente de verdad)
      _cds_communeId:      String(communeId),
      _cds_locationId:     getLocation(communeId),
      // Compatibilidad Amplifica
      amplifica_comuna_id: String(communeId),
      // Compatibilidad Zapiet / otros
      comuna_id:           String(communeId),
    };
    if (communeName) {
      attrs['_cds_communeName']  = communeName;
      attrs['_selectedComuna']   = communeName;
      attrs['_selectedComunaId'] = String(communeId);
    }
    if (region) {
      attrs['amplifica_region_id'] = region.id;
      attrs['region_id']           = region.id;
      attrs['region_text']         = region.name;
    }
    // Retorna la Promise para que syncFromCart pueda esperarla
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function(e) {
      console.warn('[CDS] Error actualizando cart attributes:', e);
    });
  }

  // ─── Estilos ──────────────────────────────────────────────────────────────
  function buildStyles() {
    var css = [
      /* Overlay */
      '#cds-modal-overlay{',
        'position:fixed;inset:0;z-index:99998;',
        'background:rgba(0,0,0,0.6);',
        'display:flex;align-items:center;justify-content:center;',
        'font-family:"Maven Pro",sans-serif;',
      '}',
      /* Contenedor */
      '#cds-modal-container{',
        'background:#fff;border-radius:4px;',
        'width:min(520px,95vw);',
        'display:flex;flex-direction:column;',
        'overflow:hidden;',
        'position:relative;',
      '}',
      /* Header */
      '#cds-modal-header{',
        'padding:30px 30px 10px;',
        'position:relative;',
      '}',
      '#cds-modal-header h2{',
        'margin:0 40px 0 0;',
        'font-size:20px;font-weight:700;',
        'color:rgba(18,18,18,0.75);',
        'line-height:1.3;',
      '}',
      '#cds-modal-close{',
        'position:absolute;top:16px;right:16px;',
        'background:#fff;border:none;cursor:pointer;',
        'color:rgba(18,18,18,0.75);',
        'font-size:20px;line-height:1;padding:4px 8px;',
        'border-radius:2px;',
      '}',
      '#cds-modal-close:hover{color:rgba(18,18,18,1);}',
      /* Contenido */
      '#cds-modal-content{',
        'padding:0 30px 30px;',
        'background-image:url("' + (window.__CDS_SELLO_URL__ || '') + '");',
        'background-repeat:no-repeat;',
        'background-position:100% 0%;',
        'background-size:contain;',
      '}',
      '#cds-modal-content p{',
        'font-size:17px;color:rgba(0,0,0,0.8);',
        'margin:0 0 20px;',
      '}',
      /* Selects */
      '.cds-select{',
        'width:100%;font-size:17px;',
        'border:0.8px solid rgb(151,32,29);border-radius:5px;',
        'padding:8px 10px;background:#fff;',
        'color:rgba(18,18,18,0.75);',
        'margin-bottom:16px;',
        'font-family:inherit;',
        '-webkit-appearance:none;appearance:none;',
        'background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23666\' stroke-width=\'2\'%3E%3Cpolyline points=\'6 9 12 15 18 9\'/%3E%3C/svg%3E");',
        'background-repeat:no-repeat;background-position:right 10px center;',
        'cursor:pointer;outline:none;',
      '}',
      '.cds-select:focus{border-color:rgb(151,32,29);}',
      '.cds-select:disabled{opacity:0.5;cursor:default;}',
      /* Botón guardar */
      '#cds-modal-save{',
        'width:100%;padding:10px 28px;',
        'background:rgb(151,32,29);color:#fff;',
        'border:none;border-radius:5px;',
        'font-size:17px;font-weight:600;',
        'text-transform:uppercase;',
        'cursor:pointer;font-family:inherit;',
        'letter-spacing:0.03em;',
      '}',
      '#cds-modal-save:hover{background:rgb(120,24,22);}',
      '#cds-modal-save:disabled{background:#ccc;cursor:not-allowed;}',
      /* Botón header toggle */
      '#cds-toggle-btn{',
        'background:none;border:none;cursor:pointer;',
        'color:inherit;font-family:inherit;font-size:inherit;',
        'padding:0;',
      '}',
    ].join('');

    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ─── Modal ────────────────────────────────────────────────────────────────
  function buildModal() {
    var saved = getSaved();
    var initialRegion = saved
      ? REGIONS.find(function(r) { return r.communes.some(function(c) { return c.id === saved.communeId; }); })
      : null;

    var overlay = document.createElement('div');
    overlay.id = 'cds-modal-overlay';

    var communeOptionsHtml = initialRegion
      ? ['<option value="">Elegir</option>']
          .concat(initialRegion.communes.map(function(c) {
            return '<option value="' + c.id + '"' + (c.id === saved.communeId ? ' selected' : '') + '>' + c.name + '</option>';
          })).join('')
      : '<option value="">Elegir</option>';

    overlay.innerHTML = [
      '<div id="cds-modal-container" role="dialog" aria-modal="true" aria-labelledby="cds-modal-title">',
        '<div id="cds-modal-header">',
          '<h2 id="cds-modal-title">',
            saved
              ? 'Estás viendo el stock en ' + saved.communeName
              : 'Selecciona tu región y comuna',
          '</h2>',
          '<button id="cds-modal-close" aria-label="Cerrar">&#x2715;</button>',
        '</div>',
        '<div id="cds-modal-content">',
          '<p>Si deseas ver el stock de otra comuna, modifícalo aquí.</p>',
          '<select class="cds-select" id="cds-region-sel">',
            '<option value="">Elegir</option>',
            REGIONS.map(function(r) {
              return '<option value="' + r.id + '"' + (initialRegion && initialRegion.id === r.id ? ' selected' : '') + '>' + r.name + '</option>';
            }).join(''),
          '</select>',
          '<select class="cds-select" id="cds-commune-sel"' + (initialRegion ? '' : ' disabled') + '>',
            communeOptionsHtml,
          '</select>',
          '<button id="cds-modal-save"' + (saved ? '' : ' disabled') + '>GUARDAR</button>',
        '</div>',
      '</div>',
    ].join('');

    document.body.appendChild(overlay);

    var regionSel  = document.getElementById('cds-region-sel');
    var communeSel = document.getElementById('cds-commune-sel');
    var saveBtn    = document.getElementById('cds-modal-save');
    var closeBtn   = document.getElementById('cds-modal-close');

    function populateCommunes(regionId, selectedId) {
      var region = REGIONS.find(function(r) { return r.id === regionId; });
      communeSel.innerHTML = '<option value="">Elegir</option>';
      if (region) {
        region.communes.forEach(function(c) {
          var opt = document.createElement('option');
          opt.value = c.id;
          opt.textContent = c.name;
          if (c.id === selectedId) opt.selected = true;
          communeSel.appendChild(opt);
        });
        communeSel.disabled = false;
      } else {
        communeSel.disabled = true;
      }
      saveBtn.disabled = !communeSel.value;
    }

    regionSel.addEventListener('change', function() {
      populateCommunes(regionSel.value, null);
      saveBtn.disabled = true;
    });

    communeSel.addEventListener('change', function() {
      saveBtn.disabled = !communeSel.value;
    });

    function doSave(regionId, communeId, communeName) {
      save(regionId, communeId, communeName);
      updateToggleBtn(communeName);
      overlay.remove();
    }

    function applyAdjustments(cartItems, unavailable, adjustments) {
      var unavailSet = {};
      unavailable.forEach(function(vid) { unavailSet[String(vid)] = true; });
      var changes = cartItems.reduce(function(acc, item) {
        var vid = String(item.variant_id);
        var newQty = unavailSet[vid] ? 0
                   : adjustments[vid] !== undefined ? adjustments[vid]
                   : null;
        if (newQty !== null) {
          acc.push(fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: newQty }),
          }));
        }
        return acc;
      }, []);
      return Promise.all(changes);
    }

    function renderZoneModal(confirmFn, html) {
      var content = document.getElementById('cds-modal-content');
      if (!content) { console.warn('[CDS] renderZoneModal: cds-modal-content no encontrado'); return; }
      content.innerHTML =
        html +
        '<div style="display:flex;gap:12px;margin-top:20px;">' +
          '<button data-cds-confirm style="flex:1;padding:10px 16px;' +
            'background:rgb(151,32,29);color:#fff;border:none;border-radius:5px;' +
            'font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;">' +
            'Confirmar cambio' +
          '</button>' +
          '<button data-cds-cancel style="flex:1;padding:10px 16px;' +
            'background:#f0f0f0;color:#333;border:none;border-radius:5px;' +
            'font-size:15px;cursor:pointer;font-family:inherit;">' +
            'Cancelar' +
          '</button>' +
        '</div>';
      // event delegation en content — más robusto que getElementById tras innerHTML
      content.addEventListener('click', function handler(e) {
        if (e.target.closest('[data-cds-confirm]')) {
          content.removeEventListener('click', handler);
          confirmFn();
        } else if (e.target.closest('[data-cds-cancel]')) {
          content.removeEventListener('click', handler);
          overlay.remove();
        }
      });
    }

    function showAdjustmentWarning(regionId, communeId, communeName, cartItems, unavailable, adjustments) {
      var unavailSet = {};
      unavailable.forEach(function(vid) { unavailSet[String(vid)] = true; });

      // diagnóstico — visible en DevTools console
      console.log('[CDS] cart-check unavailable:', unavailable);
      console.log('[CDS] cart-check adjustments:', adjustments);
      console.log('[CDS] cartItems variant_ids:', cartItems.map(function(i) { return String(i.variant_id); }));

      var lines = cartItems
        .filter(function(item) {
          var vid = String(item.variant_id);
          return unavailSet[vid] || adjustments[vid] !== undefined;
        })
        .map(function(item) {
          var vid  = String(item.variant_id);
          var name = item.title + (item.variant_title && item.variant_title !== 'Default Title'
                       ? ' · ' + item.variant_title : '');
          if (unavailSet[vid]) {
            return '<li><strong>' + name + '</strong>: eliminado (sin stock en esta sucursal)</li>';
          }
          return '<li><strong>' + name + '</strong>: de ' + item.quantity + ' a ' + adjustments[vid] + ' unidades</li>';
        }).join('');

      var listHtml = lines
        ? '<ul style="font-size:14px;color:rgba(0,0,0,0.75);margin:4px 0 0;padding-left:20px;">' + lines + '</ul>'
        : '';

      var bodyHtml =
        '<p style="font-size:16px;color:rgba(0,0,0,0.8);margin:0 0 4px;">' +
          'Al cambiar a <strong>' + communeName + '</strong>, tu carrito se ajustará:' +
        '</p>' + listHtml;

      renderZoneModal(function() {
        applyAdjustments(cartItems, unavailable, adjustments)
          .then(function() {
            doSave(regionId, communeId, communeName);
            // Esperar que cart attributes queden escritos antes de recargar
            return updateCartAttributes(communeId, communeName);
          })
          .then(function() {
            window.location.reload();
          })
          .catch(function(e) {
            console.warn('[CDS] applyAdjustments error:', e);
            doSave(regionId, communeId, communeName);
            window.location.reload();
          });
      }, bodyHtml);
    }

    function showGenericWarning(regionId, communeId, communeName) {
      var bodyHtml = '<p style="font-size:16px;color:rgba(0,0,0,0.8);margin:0;">Al cambiar a ' +
        '<strong>' + communeName + '</strong>, algunos productos podrían ajustarse automáticamente ' +
        'según el stock disponible en esa sucursal.</p>';
      renderZoneModal(function() {
        doSave(regionId, communeId, communeName);
      }, bodyHtml);
    }

    saveBtn.addEventListener('click', function() {
      var communeId   = parseInt(communeSel.value, 10);
      var communeName = communeSel.options[communeSel.selectedIndex].text;
      var regionId    = regionSel.value;

      var prevSaved = getSaved();
      var prevLoc   = prevSaved ? getLocation(prevSaved.communeId) : null;
      var newLoc    = getLocation(communeId);

      if (!prevLoc || prevLoc === newLoc) {
        doSave(regionId, communeId, communeName);
        return;
      }

      // Sucursal distinta — consultar stock en la nueva location
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (!cart.item_count) {
            doSave(regionId, communeId, communeName);
            return;
          }
          var variantIds = cart.items.map(function(i) { return String(i.variant_id); });
          var quantities = {};
          cart.items.forEach(function(i) { quantities[String(i.variant_id)] = i.quantity; });

          fetch(CDS_BACKEND + '/availability/cart-check', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ locationId: newLoc, variantIds: variantIds, quantities: quantities }),
          })
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var unavailable = data.unavailable || [];
              var adjustments = data.adjustments  || {};
              if (!unavailable.length && !Object.keys(adjustments).length) {
                doSave(regionId, communeId, communeName);
              } else {
                showAdjustmentWarning(regionId, communeId, communeName, cart.items, unavailable, adjustments);
              }
            })
            .catch(function() { showGenericWarning(regionId, communeId, communeName); });
        })
        .catch(function() { doSave(regionId, communeId, communeName); });
    });

    // Cerrar solo si ya hay selección previa
    if (!saved) {
      // Primera visita: forzar selección — no se puede cerrar de ninguna forma
      closeBtn.style.display = 'none';

      // Bloquear clicks en el overlay (impide que Dawn u otros scripts lo cierren)
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) { e.stopImmediatePropagation(); e.preventDefault(); }
      }, true);

      // Bloquear Escape a nivel documento mientras el modal esté abierto
      var blockEscape = function(e) {
        if (e.key === 'Escape') { e.stopImmediatePropagation(); e.preventDefault(); }
      };
      document.addEventListener('keydown', blockEscape, true);

      // Limpiar el listener cuando se guarda la selección
      saveBtn.addEventListener('click', function() {
        document.removeEventListener('keydown', blockEscape, true);
      }, { once: true });

    } else {
      closeBtn.addEventListener('click', function() { overlay.remove(); });
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) overlay.remove();
      });
      overlay.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') overlay.remove();
      });
    }

    setTimeout(function() { regionSel.focus(); }, 100);
  }

  // ─── Botón del header ─────────────────────────────────────────────────────
  function updateToggleBtn(communeName) {
    var displays = document.querySelectorAll('[data-cds-commune-display]');
    displays.forEach(function(el) { el.textContent = communeName || ''; });
  }

  function initToggleBtn() {
    var saved = getSaved();
    if (saved) updateToggleBtn(saved.communeName);

    document.querySelectorAll('[data-cds-open-selector]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!document.getElementById('cds-modal-overlay')) buildModal();
      });
    });
  }

  // ─── Interceptar checkout sin comuna ────────────────────────────────────────
  // Bloquea navegación al checkout si no hay comuna seleccionada.
  // Funciona en capture phase para interceptar antes que cualquier otro handler.
  function interceptCheckout() {
    // Clicks en links y botones de checkout
    document.addEventListener('click', function(e) {
      var el = e.target.closest('[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (!el) return;
      if (getSaved()) return; // hay comuna, dejar pasar
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!document.getElementById('cds-modal-overlay')) buildModal();
    }, true);

    // Submit de formularios de carrito (cart page)
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart') === -1) return;
      if (!form.querySelector('[name="checkout"]')) return;
      if (getSaved()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!document.getElementById('cds-modal-overlay')) buildModal();
    }, true);
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  // Sincroniza localStorage ↔ cart attributes.
  // Llama a updateCartAttributes SOLO cuando hay una diferencia real que resolver,
  // para evitar disparar un POST a /cart/update.js en cada carga de página
  // (lo que bloqueaba el botón de checkout en estado "loading" y requería doble click).
  function syncFromCart(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var attrs       = cart.attributes || {};
        var cartComId   = parseInt(attrs['_cds_communeId'] || attrs['amplifica_comuna_id'] || '0', 10);
        var cartComName = attrs['_selectedComuna'] || '';
        var saved       = getSaved();

        if (!cartComId || !cartComName) {
          // El carrito no tiene comuna — escribir y ESPERAR antes de continuar
          // (evita race condition si el cliente hace click en checkout enseguida)
          if (saved) {
            updateCartAttributes(saved.communeId, saved.communeName)
              .then(callback)
              .catch(callback);
          } else {
            callback();
          }
          return;
        }

        if (saved && saved.communeId === cartComId) {
          // Ya está en sincronía — NO hacer ningún POST al carrito
          callback();
          return;
        }

        // El checkout actualizó la comuna — sincronizar localStorage y refrescar carrito
        var allCommunes = [];
        REGIONS.forEach(function(r) { r.communes.forEach(function(c) { allCommunes.push({ r: r, c: c }); }); });
        var match = allCommunes.find(function(x) { return x.c.id === cartComId; });
        if (match) {
          var data = { regionId: match.r.id, communeId: cartComId, communeName: cartComName, ts: Date.now() };
          try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch(e) {}
          updateCartAttributes(cartComId, cartComName);
        }
        callback();
      })
      .catch(function() { callback(); });
  }

  function init() {
    buildStyles();
    interceptCheckout();

    syncFromCart(function() {
      initToggleBtn();
      var saved = getSaved();
      if (!saved) {
        buildModal();
        return;
      }
      // syncFromCart ya manejó cualquier actualización necesaria del carrito.
      // No llamar updateCartAttributes aquí — evita el POST innecesario que
      // bloqueaba el botón de checkout con estado loading.
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
